<template>
    <div>
        <Panel title="资源监听查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" icon="el-icon-fa-search" @click="pageTable.handleLoad()">查询</el-button>
                <el-button title="重置" class="yellow" icon="el-icon-fa-refresh" @click="pageTable.handleReset()">重置</el-button>
            </template>
            <el-form>
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="业务名称">
                            <el-input v-model="pageTable.param.bizname"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="资源监听列表">
            <template slot="buttons">
                <!--                <el-button title="全部启动" class="green" icon="el-icon-fa-play" @click="handleStartAll">全部启动</el-button>-->
                <!--                <el-button title="全部停止" class="red" icon="el-icon-fa-stop" @click="handleStopAll">全部停止</el-button>-->
                <el-button title="启动" class="green" icon="el-icon-fa-play" @click="handleStartSelection">启动</el-button>
                <el-button title="停止" class="red" icon="el-icon-fa-stop" @click="handleStopSelection">停止</el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading" ref="table"
                      @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 280px)">

                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>

                <el-table-column prop="csdefn" label="发送者标识" show-tooltip-when-overflow align="center"/>
                <el-table-column prop="csptdefn" label="发送协议" align="center" width="80"/>
                <el-table-column prop="csconf" label="发送资源" show-tooltip-when-overflow align="center">
                    <template slot-scope="{row}">
                        {{ ConnectionUtils.resourceInterception(row.csconf, row.csptdefn, 'cs') }}
                    </template>
                </el-table-column>

                <el-table-column prop="pddefn" label="接受者标识" show-tooltip-when-overflow align="center"/>
                <el-table-column prop="pdptdefn" label="接收协议" align="center" width="80"/>
                <el-table-column prop="pdconf" label="接受资源" show-tooltip-when-overflow align="center">
                    <template slot-scope="{row}">
                        {{ ConnectionUtils.resourceInterception(row.pdconf, row.pdptdefn, 'pd') }}
                    </template>
                </el-table-column>

                <el-table-column prop="csstatus" label="运行状态" width="100" align="center">
                    <template slot-scope="{ row }">
                        <el-tag v-if="row.csstatus === '-1'" type="warning">初始化失败</el-tag>
                        <el-tag v-else-if="row.csstatus === '0'" type="success">未初始化</el-tag>
                        <el-tag v-else-if="row.csstatus === '1'" type="success">初始化成功</el-tag>
                        <el-tag v-else-if="row.csstatus === '2'" type="success">已启动</el-tag>
                        <el-tag v-else-if="row.csstatus === '-2'" type="warning">已停用</el-tag>
                        <el-tag v-else-if="row.csstatus === '-3'" type="danger">已停止</el-tag>
                        <el-tag v-else>初始化</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="{row}">
                        <el-button class="green" title="启动" icon="el-icon-fa-play" @click="handleStart(row.csuuid)">启动</el-button>
                        <el-button class="red" title="停止" icon="el-icon-fa-stop" @click="handleStop(row.csuuid)">停止</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>


    </div>
</template>
<script>
import {PageTable} from 'cnetong-core-frontend';
import MonitorApi from "./Monitor";
import ConnectionUtils from '@/libs/ConnectionUtils';

export default {
    props: {},
    components: {},
    data() {
        return {
            ConnectionUtils,
            pageTable: new PageTable({
                doLoad: MonitorApi.query,
                autoLoad: true
            }),
            selection: []
        }
    },
    watch() {
    },
    mounted() {
    },
    methods: {
        handleSelectionChange(val) {
            this.selection = val;
        },
        async handleStartAll() {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await MonitorApi.startAll();
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async handleStopAll() {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await MonitorApi.stopAll();
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async handleStartSelection() {
            if (this.selection.length === 0) {
                this.$message.warning('请选择数据');
                return;
            }
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                let uuids = this.selection.map(v => v.uuid);
                await MonitorApi.start(uuids);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async handleStopSelection() {
            if (this.selection.length === 0) {
                this.$message.warning('请选择数据');
                return;
            }

            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                let uuids = this.selection.map(v => v.uuid);
                await MonitorApi.stop(uuids);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async handleStop(uuid) {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await MonitorApi.stop([uuid]);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        async handleStart(uuid) {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await MonitorApi.start([uuid]);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
    }
}
</script>
<style scoped>
</style>